import { ClassValue } from 'clsx';
import { RRule } from 'rrule';

import { cn as cn2 } from './cn';

export function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function cn(...inputs: ClassValue[]) {
  return cn2(...inputs);
}

function getPastYearLastMonday(year: number): Date {
  // Implementation for GetPastYearLastMonday needs to be defined based on Golang logic
  // Example logic: Find the last Monday of the previous year
  let date = new Date(year - 1, 11, 31); // Dec 31st of previous year
  while (date.getDay() !== 1) {
    // 1 is Monday
    date.setDate(date.getDate() - 1);
  }
  return date;
}

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function endOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

function getDateTen(date: Date): [Date, Date] {
  let year = date.getFullYear();
  if (date.getMonth() === 11) {
    // December
    year += 1;
  }

  const r = new RRule({
    freq: RRule.DAILY,
    count: 100,
    interval: 10,
    wkst: RRule.MO,
    dtstart: getPastYearLastMonday(year),
  });

  return [startOfDay(r.before(date, true) ?? new Date()), endOfDay(new Date(r.after(date, false)!.getTime() - 1))];
}

export function getNumberTen(date: Date): number {
  const [, endDate] = getDateTen(date);
  return Math.floor(endDate.getDay() / 10) + 1;
}

function getDateFortnight(date: Date): [Date, Date] {
  let year = date.getFullYear();
  if (date.getMonth() === 11 && date.getDate() > 25) {
    // December and after 25th
    year += 1;
  }

  const r = new RRule({
    freq: RRule.DAILY,
    count: 100,
    interval: 14,
    dtstart: getPastYearLastMonday(year),
  });

  return [startOfDay(r.before(date, true)!), endOfDay(new Date(r.after(date, false)!.getTime() - 1))];
}

export function getNumberFortnight(date: Date): number {
  const [, endDate] = getDateFortnight(date);
  const weekOfYear = getISOWeek(endDate);
  return Math.floor(weekOfYear / 2) + 1;
}

function getISOWeek(date: Date): number {
  const target = new Date(date.valueOf());
  const dayNr = (date.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
  }
  return 1 + Math.ceil((firstThursday - target.valueOf()) / 604800000); // 604800000 = 7 * 24 * 3600 * 1000
}
